var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCampaignImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 162,
    viewBox: "0 0 163 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.628 24.2969H43.4281C38.9546 24.2969 35.3281 27.9234 35.3281 32.3969V129.597C35.3281 134.07 38.9546 137.697 43.4281 137.697H140.628C145.102 137.697 148.728 134.07 148.728 129.597V32.3969C148.728 27.9234 145.102 24.2969 140.628 24.2969Z",
    fill: "#C8D2F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4865_188062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3176 85.0391H127.668C128.742 85.0391 129.772 85.4658 130.531 86.2253C131.291 86.9848 131.718 88.0149 131.718 89.0891V109.339C131.718 110.413 131.291 111.443 130.531 112.203C129.772 112.962 128.742 113.389 127.668 113.389H18.3176C17.2435 113.389 16.2133 112.962 15.4538 112.203C14.6943 111.443 14.2676 110.413 14.2676 109.339V89.0891C14.2676 88.0149 14.6943 86.9848 15.4538 86.2253C16.2133 85.4658 17.2435 85.0391 18.3176 85.0391V85.0391Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.2576 91.5156H57.1976C55.8555 91.5156 54.7676 92.6036 54.7676 93.9456C54.7676 95.2877 55.8555 96.3756 57.1976 96.3756H78.2576C79.5996 96.3756 80.6876 95.2877 80.6876 93.9456C80.6876 92.6036 79.5996 91.5156 78.2576 91.5156Z",
    fill: "#1638B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M92.8376 102.047H57.1976C55.8555 102.047 54.7676 103.135 54.7676 104.477C54.7676 105.819 55.8555 106.907 57.1976 106.907H92.8376C94.1796 106.907 95.2676 105.819 95.2676 104.477C95.2676 103.135 94.1796 102.047 92.8376 102.047Z",
    fill: "#ACBCF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4411 106.906C32.6909 106.906 36.1361 103.46 36.1361 99.2106C36.1361 94.9608 32.6909 91.5156 28.4411 91.5156C24.1913 91.5156 20.7461 94.9608 20.7461 99.2106C20.7461 103.46 24.1913 106.906 28.4411 106.906Z",
    fill: "#C8D2F8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4865_188062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.668 48.6016H18.3176C16.0808 48.6016 14.2676 50.4148 14.2676 52.6516V72.9016C14.2676 75.1383 16.0808 76.9516 18.3176 76.9516H127.668C129.904 76.9516 131.718 75.1383 131.718 72.9016V52.6516C131.718 50.4148 129.904 48.6016 127.668 48.6016Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.6365 55.0781H55.5765C54.2344 55.0781 53.1465 56.1661 53.1465 57.5081C53.1465 58.8502 54.2344 59.9381 55.5765 59.9381H76.6365C77.9785 59.9381 79.0665 58.8502 79.0665 57.5081C79.0665 56.1661 77.9785 55.0781 76.6365 55.0781Z",
    fill: "#1638B1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M91.2165 65.6094H55.5765C54.2344 65.6094 53.1465 66.6973 53.1465 68.0394C53.1465 69.3814 54.2344 70.4694 55.5765 70.4694H91.2165C92.5585 70.4694 93.6465 69.3814 93.6465 68.0394C93.6465 66.6973 92.5585 65.6094 91.2165 65.6094Z",
    fill: "#ACBCF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9684 70.4759C43.2183 70.4759 46.6634 67.0308 46.6634 62.7809C46.6634 58.5311 43.2183 55.0859 38.9684 55.0859C34.7186 55.0859 31.2734 58.5311 31.2734 62.7809C31.2734 67.0308 34.7186 70.4759 38.9684 70.4759Z",
    fill: "#C8D2F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4865_188062",
    x: 9.40758,
    y: 82.6091,
    width: 127.169,
    height: 38.0716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.43
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4865_188062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4865_188062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4865_188062",
    x: 9.40758,
    y: 46.1716,
    width: 127.169,
    height: 38.0716,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.43
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4865_188062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4865_188062",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCampaignImage);
export default __webpack_public_path__ + "static/media/no-campaign-image.241a997732610b5647283418c2e7664a.svg";
export { ForwardRef as ReactComponent };